<template>
  <div class="container-fluid">
                    <loader v-show="loader" object="#29B3A6" color1="#29B3A6" color2="#17fd3d" size="4" speed="1" bg="#343a40" objectbg="#999793" opacity="80" name="spinning"></loader>

  <div class="mb-3">
   <v-btn @click="$router.go(-1)" outlined style="border: none;background: #fff" class="mt-3" title="Retourner">
          <v-icon>mdi mdi-arrow-left</v-icon> Mes transactions
         </v-btn>
  </div>
    <v-row v-if="transaction_details">
       <v-col cols="12" lg="3" md="4" class="mt-0 pt-0 mb-0 pb-0">
        <v-card style="padding: 15px;padding-top:5px;padding-bottom:5px;">
          <div class="row"  style="background: #fff">
            <div class="col-md-12 pt-2 pb-0">
              <v-icon large>mdi-swap-horizontal</v-icon>
            </div>
            <div class="col-md-12 ">
              <div>Désignation :</div>
              <div style="font-weight: bold" class="text-uppercase">
                {{ transaction_details._marchand_client_transaction._name }}
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
       <v-col cols="12" lg="3" md="4" class="mt-0 pt-0 mb-0 pb-0">
        <v-card style="padding: 15px;padding-top:5px;padding-bottom:5px;">
          <div class="row"  style="background: #fff">
            <div class="col-md-12 pt-2 pb-0">
              <v-icon large>mdi-recycle</v-icon>
            </div>
            <div class="col-md-12 ">
              <div>Type de programmation :</div>
              <div style="font-weight: bold" class="text-uppercase">
                {{ transaction_details._type_programmation }}
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" lg="3" md="4" class="mt-0 pt-0 mb-0 pb-0">
        <v-card style="padding: 15px;padding-top:5px;padding-bottom:5px;">
          <div class="row" style="background: #fff">
            <div class="col-md-12 pt-2 pb-0">
              <v-icon large>mdi-calendar</v-icon>
            </div>
            <div class="col-md-12 ">
              <div>Démmarre le :</div>
              <div style="font-weight: bold">
                {{ getDate(transaction_details._date_programme) }}
              </div>
            </div>
          </div>

        </v-card>
      </v-col>
       <v-col  cols="12" lg="3" md="4" class="mt-0 pt-0">
                      <v-card style="padding: 15px;padding-top:5px;padding-bottom:5px;">
                        <div class="row"  style="background: #fff">
                          <div class="col-md-12 pt-2 pb-0">
                            <v-icon large>mdi-message-badge-outline</v-icon>
                          </div>
                          <div class="col-md-12 ">
                            <div>Canal de Transmission:</div>
                            <div style="font-weight: bold">
                              {{  transaction_details._canal_transmission  }}  </div>
                          </div>
                        </div>

                      </v-card>
                    </v-col>
      <v-col cols="12" lg="3" md="4" class="mt-0 pt-0 mb-0 pb-0">
        <v-card style="padding: 15px;padding-top:5px;padding-bottom:5px;">
          <div class="row"  style="background: #fff">
            <div class="col-md-12 pt-2 pb-0">
              <v-icon large>mdi-cash-multiple</v-icon>
            </div>
            <div class="col-md-12 ">
              <div>Montant total à payer:</div>
              <div style="font-weight: bold"> {{ transaction_details._marchand_client_transaction._amount }} XOF 
                <span class="float-right badge badge-warning" style="font-size:8px!important">
                  {{transaction_details._marchand_client_transaction._fees_support ? 'frais supportés' : 'Frais non supportés'}}
                </span>
              </div>
            </div>
          </div>

        </v-card>
      </v-col>
      <v-col cols="12" lg="3" md="4" class="mt-0 pt-0 mb-0 pb-0">
        <v-card style="padding: 15px;padding-top:5px;padding-bottom:5px;">
          <div class="row"  style="background: #fff">
            <div class="col-md-12 pt-2 pb-0">
              <v-icon large>mdi-list-status</v-icon>
            </div>
            <div class="col-md-12 ">
              <div>Status de la transaction:</div>
              <div style="font-weight: bold">
                <span :class="transaction_details._marchand_client_transaction._archive ? 'badge badge-danger text-uppercase' : (transaction_details._marchand_client_transaction._status ? 'badge badge-success text-uppercase' : 'badge badge-warning text-uppercase')">  
                  {{ transaction_details._marchand_client_transaction._archive ? 'archiver' :  (transaction_details._marchand_client_transaction._status ? 'Terminer' : 'en cours') }}
                </span>
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
     
    </v-row>
    <v-row v-if="transaction_details">
      <v-col>
        <v-card elevation="0">
          <v-tabs v-model="transactions_tabs" class="mb-3">
            <v-tab>Clients liés</v-tab>
            <v-tab>Produits de la transaction</v-tab>
            <v-tab>Informations de paiement</v-tab>
          </v-tabs>
          <v-tabs-items v-model="transactions_tabs">
               <v-tab-item>
                <h5 style="padding: 10px;" class="mt-0 mb-0">Liste des clients liés à la transaction</h5>
                <v-data-table :items="transaction_details._marchand_client_transaction._clients_transaction" :headers="linkedClientsHeaders">
                  <template v-slot:item._category="{ item }">
                    <div>
                      {{ item._category._name }}
                    </div>
                  </template>
                   <template v-slot:item.actions="{item}">
                    <div>
                      <button @click="getClientTransactionsData(transaction_details,item._id)" class="btn-sm btn btn-light">Logs des paiements</button> &nbsp;
                      <router-link :to="'/all-customers-transactions?details='+item._id" class="btn-sm btn btn-outline-primary">Détails client</router-link>
                    </div>
                  </template>
                  </v-data-table>
              </v-tab-item>
                <v-tab-item>
                  <h5 style="padding: 10px;" class="mt-0 mb-0">Liste des Produits associés à la transaction</h5>
            <v-data-table :items="transaction_details._marchand_client_transaction._client_product_transaction" :headers="headersProducts">
              <template v-slot:item._image="{ item }">
                <div class="p-2">
                 <v-img
                      :src="admin_url+'/'+item._product_id._image"
                      :lazy-src="admin_url+'/'+item._product_id._image"
                      max-width="50"
                      max-height="50"
                      aspect-ratio="1"
                      class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                      >
                        <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                  </div>
              </template>
            </v-data-table>
              </v-tab-item>
              <v-tab-item>
                <h5 style="padding: 10px;" class="mt-0 mb-0">Informations de paiement</h5>
                    <table style="width: 100%" class="p-3 table table-striped">
                      <tbody>
                      <tr style="padding: 15px">
                        <td style="padding: 15px"> Référencement:</td>
                        <td>{{ transaction_details._marchand_client_transaction._reference }}</td>
                      </tr>
                      <tr style="padding: 15px">
                        <td style="padding: 15px"> Montant:</td>
                        <td>{{ formatAmount(transaction_details._marchand_client_transaction._amount) + ' ' }} XOF</td>
                      </tr>
                      <tr style="padding: 15px">
                        <td style="padding: 15px"> Date de la transaction:</td>
                        <td>{{ getDate(transaction_details._marchand_client_transaction._created_at) }}</td>
                      </tr>
                      <tr style="padding: 15px">
                        <td style="padding: 15px">Canal de transmission:</td>
                        <td>
                          {{ transaction_details._canal_transmission }}
                        </td>
                      </tr>
                      </tbody>
                    </table>
              </v-tab-item>
          </v-tabs-items>
       </v-card>
          <logs-paiement v-if="openPaiementLogs" :openPaiementLogs="openPaiementLogs" :transaction_data="transaction_data" :logs_transactions="logs_transactions" @closeLogsTransaction="closeLogsTransaction"></logs-paiement>
        </v-col>
    </v-row>
  </div>
</template>

<script>
import {client} from "../../store/services/client";
import helpers from '../../mixins/helpers'
import {env} from "../../../env";
export default {
  name: "MarchandTransactionDetails",
  mixins:[helpers(this)],
  data() {
    return {
      openPaiementLogs:false,
      transaction_data:undefined,
      logs_transactions:undefined,
      loader:false,
      admin_url:env.admin,
      transactions_tabs:null,
      transaction_details: null,
      linkedClientsHeaders: [
        {text: '', value: 'actions', sortable: false},
        {text: 'Nom', value: '_last_name'},
        {text: 'Prénom', value: '_first_name'},
        {text: 'Catégorie de client', value: '_category'},
        {text: 'Email', value: '_email'},
        {text: 'Téléphone', value: '_phone'},
        {text: 'Adresse', value: '_address'},
      ],
      headersProducts: [
        {text: '-', value: '_image'},
        {text: 'Nom Produit', value: '_product_id._name'},
        {text: 'Prix', value: '_product_id._price'},
        {text: 'Description', value: '_product_id._description'},
        {text: '', value: 'actions', sortable: false},
      ],
      products: [],
      linkedClients: []
    }
  },
  created() {
    this.getCurrentTransactionDetails()
    this.checkisDashboard();
  },
  methods: {
     closeLogsTransaction(){
      this.openPaiementLogs = false
      this.transaction_data=undefined;
      this.logs_transactions=undefined;
    },
    async getClientTransactionsData(data,id){
         this.loader= true;
        // this.transaction_data=data._marchand_client_transaction;
        // this.transaction_data._programmation= data;
        const response = await client({
          method: 'post',
          url: `/transactions/get/by/`+id,
          data: {transaction_id : this.$route.params.transaction_id}
        })
            .then(res => res.data)
            .catch(error => {
              console.log(error)
              return {
                error: true
              }
            })
        if(response && !response.error)
          this.logs_transactions = response.transactions
          this.loader= false;
          this.openPaiementLogs=true;
        },
    checkisDashboard() {
      this.$emit('checkisDashboard', true);
    },
    async getCurrentTransactionDetails() {
      this.loader=true;
      await client({
        method: 'get',
        url: '/marchand/get_transaction_details/' + this.$route.params.transaction_id,
      })
          .then(resp => {
            this.transaction_details = resp.data.transaction;
            this.loader=false;
          })
          .catch(error => {
            console.log(error)
            this.loader=false;
            return {
              error: "true"
            }
          })
    }
  }
}
</script>

<style scoped>

</style>
